/* eslint-disable max-lines */
import { ProfileType } from '../../../../types/common.types';
import { FooterInformation } from '../../footer-slim/models/footer-slim.interfaces';
import { AuxiliaryNavigationEntity } from './header.auxiliary.nav.interfaces';
import { PrimaryNavigationEntity } from './header.primary.nav.interfaces';
import { SecondaryNavigationEntity } from './header.secondary.nav.interfaces';

/** AEM Header Content interface */

/** Holds Slim Header content which includes logo & page heading title  */
export interface HeaderSlim {
  logo: Logo;
  title?: string;
  profile?: ProfileType;
  lightHeader: boolean;
}

/** Holds all Header information/text that is coming from AEM */
export interface Header extends Partial<HeaderSlim> {
  primaryNavigation?: PrimaryNavigationEntity[] | null;
  secondaryNavigation?: SecondaryNavigationEntity[] | null;
  auxiliaryNavigation?: AuxiliaryNavigationEntity[] | null;
  standaloneWidget: string;
  modelPopUps?: ModelPopUpsEntity[] | null;
  disableBusinessHomePage: string;
}

/** Holds all types (Desktop/Mobile & Business/Personal Profile) of Logo information */
export interface Logo {
  mainLogo: string;
  mainLogoUrl: string;
  mainLogoAltText: string;
  mainLogoNewTab: string;
  subLogo: string;
  subLogoUrl: string;
  subLogoAltText: string;
  subLogoNewTab: string;
  busiLogo: string;
  busiLogoUrl: string;
  busiLogoAltText: string;
  busiLogoNewTab: string;
  slimheaderLogo: string;
  slimheaderLogoUrl: string;
  slimheaderLogoAltText: string;
  slimheaderLogoNewTab: string;
}

/** Holdes modal content information E.g., "Corporate Rewards Model", "Negotiated Fares Model" */
export interface ModelPopUpsEntity {
  modelId: string;
  modelTitle: string;
  modelDescription: string;
  firstButtonText: string;
  submitUrl: string;
  secondButtonText: string;
}

export interface HeaderFooterSlim {
  header: HeaderSlim;
  footer: FooterInformation;
}
